module.exports = __webpack_public_path__ + "static/media/09_background.34c44856.png";